module.exports = __webpack_public_path__ + "static/media/deep-navy.82ca626d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/deep-navy.jpeg
// module id = 2038
// module chunks = 0